import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { useSlotProps } from "../../../base/index.js";
import { useCalendarConfiguration } from "../context/index.js";
import { calendarDayName, useCalendarDayUtilityClasses } from "./classes.js";
import { Button } from "./components/Button.js";
import { Dot } from "./components/Dot.js";
import { Label } from "./components/Label.js";
import { Root } from "./components/Root.js";
import { Separator } from "./components/Separator.js";
import { Tooltip } from "./components/Tooltip.js";
function CalendarDay(inProps) {
  const props = useThemeProps({
    name: calendarDayName,
    props: inProps
  });
  const { day, testId = `${calendarDayName}-root`, className, components, componentsProps } = props;
  const {
    layout: { daySize, dayGapX },
    palette,
    highlightToday
  } = useCalendarConfiguration();
  const label = day.type !== "empty" && day.label;
  const disabled = day.type === "day" && day.disabled;
  const tooltipText = day.type === "day" && day.tooltipText;
  const highlighted = day.type === "day" && day.isHighlighted;
  const isFirstNonArchivedDate = day.type === "day" && day.isFirstNonArchivedDate;
  const ownerState = props;
  const utilityClasses = useCalendarDayUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    className: [className, utilityClasses.root],
    ownerState,
    elementType: Root,
    additionalProps: {
      as: components?.Root,
      dayGapX,
      "data-testid": testId
    },
    externalSlotProps: componentsProps?.root
  });
  const buttonSlotProps = useSlotProps({
    className: utilityClasses.button,
    ownerState,
    elementType: Button,
    additionalProps: {
      as: components?.Button,
      type: "button",
      daySize,
      palette,
      "data-calendar": day.type,
      ...day.type === "day" && {
        "data-day": day.id,
        "data-reset-selection": disabled ? "1" : "0",
        ...day.isToday && {
          "data-testid": "today"
        }
      }
    },
    externalSlotProps: componentsProps?.button
  });
  const labelSlotProps = useSlotProps({
    className: utilityClasses.label,
    ownerState,
    elementType: Label,
    additionalProps: {
      as: components?.Label,
      highlightToday
    },
    externalSlotProps: componentsProps?.label
  });
  const dotSlotProps = useSlotProps({
    className: utilityClasses.dot,
    ownerState,
    elementType: Dot,
    additionalProps: { as: components?.Dot },
    externalSlotProps: componentsProps?.dot
  });
  const separatorSlotProps = useSlotProps({
    className: utilityClasses.separator,
    ownerState,
    elementType: Separator,
    additionalProps: {
      as: components?.Separator,
      "data-testid": "first-ops-day"
    },
    externalSlotProps: componentsProps?.separator
  });
  const tooltipSlotProps = useSlotProps({
    className: utilityClasses.tooltip,
    ownerState,
    elementType: Tooltip,
    additionalProps: {
      as: components?.Tooltip,
      title: tooltipText
    },
    externalSlotProps: componentsProps?.tooltip
  });
  return /* @__PURE__ */ jsxs(Root, { ...rootSlotProps, children: [
    isFirstNonArchivedDate && /* @__PURE__ */ jsx(Separator, { ...separatorSlotProps }),
    /* @__PURE__ */ jsx(Button, { ...buttonSlotProps, children: /* @__PURE__ */ jsx(Tooltip, { ...tooltipSlotProps, children: /* @__PURE__ */ jsxs(Fragment, { children: [
      label && /* @__PURE__ */ jsx(Label, { ...labelSlotProps, children: label }),
      highlighted && /* @__PURE__ */ jsx(Dot, { ...dotSlotProps })
    ] }) }) })
  ] });
}
export {
  CalendarDay
};
//# sourceMappingURL=CalendarDay.js.map
